import { ImageType } from '@/types/common';

const PATH_TO_SHIP_TYPE_ICONS = '/public/ship-type-icon-list/';
const PATH_TO_GUIDE_IMAGES = '/public/guide/';

const PATH_TO_ICONS = '/public/icons/';
const PATH_TO_SOCIAL = `${PATH_TO_ICONS}social/`;
const PATH_TO_TOAST = `${PATH_TO_ICONS}toast/`;
const PATH_TO_STATS = `${PATH_TO_ICONS}stats/`;

const glob: Record<
  string,
  {
    default: string;
  }
> = import.meta.glob(
  [
    '@/public/ship-type-icon-list/*.svg',
    '@/public/icons/*.svg',
    '@/public/icons/social/*.svg',
    '@/public/icons/toast/*.svg',
    '@/public/icons/stats/*.{webp,svg}',
    '@/public/guide/**/*.{jpg,webp}',
  ],
  { eager: true }
);

const images = new Map<string, string>();
const files = Object.keys(glob);
files.forEach((file) => {
  images.set(file, glob[file]!.default);
});

const getPath = (type: ImageType): string | undefined => {
  switch (type) {
    case ImageType.Icon: {
      return PATH_TO_ICONS;
    }
    case ImageType.Ship: {
      return PATH_TO_SHIP_TYPE_ICONS;
    }
    case ImageType.Social: {
      return PATH_TO_SOCIAL;
    }
    case ImageType.Toast: {
      return PATH_TO_TOAST;
    }
    case ImageType.Guide: {
      return PATH_TO_GUIDE_IMAGES;
    }
    case ImageType.Stats: {
      return PATH_TO_STATS;
    }
    default: {
      throw new Error('Please choose the image type');
    }
  }
};

export const getImage = (type: ImageType, name: string, extension = 'svg'): string | undefined => {
  const folder = getPath(type);
  return images.get(`${folder}${name}.${extension}`);
};
